import React from 'react';
import Button from '../../../components/ui/Button';

const NavigationButtons = ({ 
  currentStep, 
  totalSteps, 
  onPrevious, 
  onNext, 
  onSaveDraft, 
  onSubmit,
  isLoading = false,
  canProceed = true 
}) => {
  const isFirstStep = currentStep === 1;
  const isLastStep = currentStep === totalSteps;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-card border-t border-border shadow-elevation-2 z-40">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between">
          {/* Left Side - Previous Button */}
          <div className="flex items-center space-x-3">
            {!isFirstStep && (
              <Button
                variant="outline"
                onClick={onPrevious}
                disabled={isLoading}
                iconName="ChevronLeft"
                iconPosition="left"
              >
                Vorige
              </Button>
            )}
          </div>

          {/* Center - Step Info */}
          <div className="hidden sm:flex items-center space-x-4 text-sm text-muted-foreground">
            <span>Stap {currentStep} van {totalSteps}</span>
            <div className="w-24 bg-border rounded-full h-2">
              <div 
                className="bg-primary h-2 rounded-full transition-all duration-300"
                style={{ width: `${(currentStep / totalSteps) * 100}%` }}
              />
            </div>
          </div>

          {/* Right Side - Action Buttons */}
          <div className="flex items-center space-x-3">
            <Button
              variant="ghost"
              onClick={onSaveDraft}
              disabled={isLoading}
              iconName="Save"
              iconPosition="left"
              size="sm"
            >
              Concept Opslaan
            </Button>

            {isLastStep ? (
              <Button
                variant="default"
                onClick={onSubmit}
                disabled={isLoading || !canProceed}
                loading={isLoading}
                iconName="Send"
                iconPosition="right"
              >
                Aanvraag Verzenden
              </Button>
            ) : (
              <Button
                variant="default"
                onClick={onNext}
                disabled={isLoading || !canProceed}
                loading={isLoading}
                iconName="ChevronRight"
                iconPosition="right"
              >
                Volgende
              </Button>
            )}
          </div>
        </div>

        {/* Mobile Step Indicator */}
        <div className="sm:hidden mt-3 flex items-center justify-center space-x-2">
          <span className="text-sm text-muted-foreground">
            Stap {currentStep} van {totalSteps}
          </span>
          <div className="w-32 bg-border rounded-full h-2">
            <div 
              className="bg-primary h-2 rounded-full transition-all duration-300"
              style={{ width: `${(currentStep / totalSteps) * 100}%` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavigationButtons;